// src/entities/user/api/useCurrentGameProfileQueryIfGameAvailable.ts
import { queries } from "@app/shared/api/Queries/Queries.ts";
import { useConfigContext } from "@entities/game/model/useConfigContext.ts";
import { getAuthToken } from "@shared/api/Auth.ts";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import log from "loglevel";

/**
 * Хук для запроса профиля пользователя в контексте текущей игры.
 * Запрос будет выполнен только в том случае, если:
 * 1. Загружена конфигурация игры (`gameConfig`).
 * 2. В приложении присутствует токен аутентификации.
 */
export const useCurrentGameProfileQueryIfGameAvailable = () => {
	// Используем наш новый централизованный хук
	const { gameConfig } = useConfigContext();
	const authToken = getAuthToken();

	const queryData = queries.profile.get({ Game: gameConfig?.GameSystemName });

	log.debug(
		"useCurrentGameProfileQueryIfGameAvailable profile data with query key %s. Auth key available: %s",
		queryData.queryKey,
		!!authToken
	);

	return useQuery({
		...queryData,
		// Запрос активен только при наличии конфига игры и токена авторизации.
		// `!!` приводит значение к boolean.
		enabled: !!authToken
	});
};
